export default __webpack_public_path__ + "static/media/NC_1400x282-left.6aa7ef28.png";